import config from '@project/config';

const baseUrl = `${config.apiUrl()}/BackOffice/Sms`;

export default {
  smsUsageReportUrl: (): string => `${baseUrl}/usage-report`,
};
